import SettingApi from 'Api/setting';

export const SETTING_LIST_REQUEST = 'SETTING_LIST_REQUEST';
export const SETTING_LIST_SUCCESS = 'SETTING_LIST_SUCCESS';
export const SETTING_LIST_ERROR = 'SETTING_LIST_ERROR';

export const SETTING_DATA_REQUEST = 'SETTING_DATA_REQUEST';
export const SETTING_DATA_SUCCESS = 'SETTING_DATA_SUCCESS';
export const SETTING_DATA_ERROR = 'SETTING_DATA_ERROR';

export const SETTING_UPDATE_REQUEST = 'SETTING_UPDATE_REQUEST';
export const SETTING_UPDATE_SUCCESS = 'SETTING_UPDATE_SUCCESS';
export const SETTING_UPDATE_ERROR = 'SETTING_UPDATE_ERROR';

/**
 * Load all instances of the model matched by filters from the data source
 *
 * @param filter
 * @returns {Object}
 */
export function load(filter = {}) {
    return {
        requestType: 'SETTING_LIST',
        request: SettingApi.find(filter),
    };
}

/**
 * Load model data
 *
 * @param {number} alias
 * @returns {*}
 */
export function loadData(alias) {
    return {
        requestType: 'SETTING_DATA',
        request: SettingApi.loadData(alias),
    };
}

/**
 * Update model data
 *
 * @param data
 * @returns {{requestType: string, request: (function(*))}}
 */
export function updateData(data) {
    console.log(data);
    return {
        requestType: 'SETTING_UPDATE',
        request: SettingApi.updateData(data)
    };
}



// WEBPACK FOOTER //
// ./src/actions/setting.js